import React from 'react';

/**
 * CrediToolsMX symbol: flat gear (automation) with a play triangle (action).
 * Colors default to the brand tokens so the mark follows the active theme.
 */
export default function BrandMark({
  size = 34,
  gearColor = 'var(--color-heading)',
  playColor = 'var(--color-brand)',
  className = '',
}) {
  return (
    <svg
      className={`brand-mark ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 40 40"
      aria-hidden="true"
      focusable="false"
    >
      <g className="brand-mark-gear">
        <circle
          cx="20"
          cy="20"
          r="15"
          fill="none"
          stroke={gearColor}
          strokeWidth="5"
          pathLength="24"
          strokeDasharray="1.15 0.85"
        />
        <circle cx="20" cy="20" r="11.5" fill="none" stroke={gearColor} strokeWidth="3.5" />
      </g>
      <path
        className="brand-mark-play"
        d="M17 14.8 L25.5 20 L17 25.2 Z"
        fill={playColor}
        stroke={playColor}
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}
